<script lang="ts">
  import { page } from '@roxi/routify'
  export let onClick: () => void
  export let destination: string
  let other = $page.path !== destination
</script>

<div>
  <button on:click={onClick} class:other disabled={!other}>
    <slot />
  </button>
</div>

<style>
  div {
    display: inline;
  }
  button {
    position: relative;
    padding: 0.2em 0;
    overflow: hidden;
    background: none;
    border: none;
    padding: 0;
    color: #fff;
    cursor: pointer;
    font-size: 1.2em;
    margin: 0 1em;
    text-transform: uppercase;
  }

  button::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.1em;
    background-color: white;
  }

  .other::after {
    transition: transform 500ms ease-in;
    transform: translate3d(-100%, 0, 0);
  }

  .other:hover::after,
  .other:focus::after {
    transform: translate3d(0, 0, 0);
  }
</style>
